/* Collection page: filters, search, sort, grouping, grid / wholesale list,
   banner. Markup and data attributes: sections/lb-collection.liquid. */
(function () {
  var root = document.querySelector('[data-lb-col]');
  if (!root) return;
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }

  var cur = root.dataset.currency || 'USD';
  var fmt;
  try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }); } catch (e) { fmt = null; }
  function money(n) { return fmt ? fmt.format(n) : cur + ' ' + n.toFixed(2); }
  var tiers = (root.dataset.tiers || '').split(',').map(function (t) { var a = t.split(':'); return { q: +a[0], p: +a[1] }; });
  function pctFor(units) { var p = 0; tiers.forEach(function (t) { if (units >= t.q) p = t.p; }); return p; }
  var notes = {}; try { notes = JSON.parse($('[data-lb-notes]').textContent || '{}'); } catch (e) {}

  var gridEl = $('[data-lb-grid]'), listEl = $('[data-lb-list]'), rowsEl = $('[data-lb-rows]');
  var promo = $('[data-lb-promo]'), empty = $('[data-lb-empty]'), bar = $('[data-lb-bar]');
  var cards = $$('[data-lb-item]', gridEl).map(function (el) {
    var d = el.dataset;
    return {
      el: el, id: d.id, pos: +d.pos, title: d.title, type: d.type, tags: d.tags.split('|').filter(Boolean),
      sku: d.sku, price: +d.price, avail: d.avail === '1', hot: d.hot === '1', pub: +d.pub || 0, badge: d.badge, color: d.color,
      hay: [d.title, d.type, d.tags.replace(/\|/g, ' '), d.sku, d.badge].join(' ').toLowerCase()
    };
  });
  var rowById = {}; $$('[data-lb-row]', rowsEl).forEach(function (r) { rowById[r.dataset.id] = r; });
  cards.forEach(function (c) { c.row = rowById[c.id]; });
  var typeOrder = []; cards.forEach(function (c) { if (c.type && typeOrder.indexOf(c.type) < 0) typeOrder.push(c.type); });

  var S = { q: '', type: [], tag: [], max: +root.dataset.max, stock: false, sort: 'featured', grp: false, mode: 'grid', per: 24, filt: false };
  var minP = +root.dataset.min, maxP = +root.dataset.max;

  /* ---- search (fuzzy: all tokens must match; 4+ letter tokens may match as a subsequence) ---- */
  function norm(x) { return String(x).toLowerCase().replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function subseq(t, h) { var i = 0; for (var k = 0; k < h.length && i < t.length; k++) if (h[k] === t[i]) i++; return i === t.length; }
  function matchQ(c) {
    if (!S.q) return true;
    var h = norm(c.hay), flat = h.replace(/ /g, '');
    return norm(S.q).split(' ').every(function (t) { return h.indexOf(t) > -1 || (t.length >= 4 && subseq(t, flat)); });
  }
  function pass(c) {
    if (S.type.length && S.type.indexOf(c.type) < 0) return false;
    /* "Works with" tags (works:ESP32-S3, ...) are alternatives, one per product: any of the ticked ones.
       Every other ticked feature must be on the product. */
    var W = S.tag.filter(function (t) { return t.indexOf('works:') === 0; }), F = S.tag.filter(function (t) { return t.indexOf('works:') !== 0; });
    if (W.length && !W.some(function (t) { return c.tags.indexOf(t) > -1; })) return false;
    if (F.length && !F.every(function (t) { return c.tags.indexOf(t) > -1; })) return false;
    if (c.price > S.max + 0.0001) return false;
    if (S.stock && !c.avail) return false;
    return matchQ(c);
  }
  function cmp(a, b) {
    var f = { az: function () { return a.title.localeCompare(b.title); }, za: function () { return b.title.localeCompare(a.title); },
      plow: function () { return a.price - b.price; }, phigh: function () { return b.price - a.price; },
      dold: function () { return a.pub - b.pub; }, dnew: function () { return b.pub - a.pub; },
      best: function () { return (b.hot - a.hot) || (a.pos - b.pos); } }[S.sort];
    return (f ? f() : 0) || (a.pos - b.pos);
  }

  /* ---- rendering ---- */
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function render() {
    var list = cards.filter(pass).sort(cmp);
    var shown = root.dataset.paged ? list : list.slice(0, S.per);
    $('[data-lb-count]').textContent = list.length;
    root.classList.toggle('is-list', S.mode === 'list');
    empty.hidden = list.length > 0;

    cards.forEach(function (c) { c.el.classList.remove('is-feat'); if (c.el.parentNode) c.el.parentNode.removeChild(c.el); if (c.row && c.row.parentNode) c.row.parentNode.removeChild(c.row); });
    $$('.lb-gsec, .lb-lgrp').forEach(function (n) { n.parentNode.removeChild(n); });

    var groups = [];
    if (S.grp) {
      typeOrder.forEach(function (t) { var g = shown.filter(function (c) { return c.type === t; }); if (g.length) groups.push({ t: t, items: g }); });
    } else groups = [{ t: null, items: shown }];

    // grid
    if (S.mode === 'grid') {
      gridEl.hidden = S.grp;
      var after = gridEl;
      groups.forEach(function (g, gi) {
        if (!S.grp) { g.items.forEach(function (c) { gridEl.appendChild(c.el); }); return; }
        var sec = el('section', 'lb-gsec');
        var hd = el('div', 'lb-gsec__hd', '<i style="background:' + esc(g.items[0].color) + '"></i><h2>' + esc(g.t) + '</h2>' + (notes[g.t] ? '<p>' + esc(notes[g.t]) + '</p>' : '') + '<span>' + g.items.length + (g.items.length === 1 ? ' product' : ' products') + '</span>');
        var gr = el('div', 'lb-grid'); g.items.forEach(function (c) { gr.appendChild(c.el); });
        sec.appendChild(hd); sec.appendChild(gr);
        after.parentNode.insertBefore(sec, after.nextSibling); after = sec;
        if (gi === 0) { after.parentNode.insertBefore(promo, after.nextSibling); after = promo; }
      });
      promo.hidden = !(S.grp && groups.length);
      if (!S.grp) { gridEl.parentNode.insertBefore(promo, gridEl.nextSibling); promo.hidden = true; }
    }
    // list
    groups.forEach(function (g) {
      if (S.grp) { var h = el('div', 'lb-lgrp', '<i style="background:' + esc(g.items[0].color) + '"></i><b>' + esc(g.t) + '</b>' + (notes[g.t] ? '<span>' + esc(notes[g.t]) + '</span>' : '')); rowsEl.appendChild(h); }
      g.items.forEach(function (c) { if (c.row) rowsEl.appendChild(c.row); });
    });
    listEl.hidden = S.mode !== 'list';
    bar.hidden = S.mode !== 'list';
    syncControls();
    updateList();
  }

  /* ---- controls ---- */
  function syncControls() {
    $$('[data-lb-f="type"]').forEach(function (i) { i.checked = S.type.indexOf(i.value) > -1; });
    $$('[data-lb-f="tag"]').forEach(function (i) { i.checked = S.tag.indexOf(i.value) > -1; });
    var st = $('[data-lb-stock]'); if (st) st.checked = S.stock;
    var pr = $('[data-lb-price]'); if (pr) pr.value = S.max;
    var pv = $('[data-lb-pv]'); if (pv) pv.textContent = money(S.max);
    var q = $('[data-lb-q]'); if (q && q.value !== S.q) q.value = S.q;
    $$('[data-lb-mode]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.lbMode === S.mode); });
    $$('[data-lb-per]').forEach(function (b) { b.classList.toggle('is-on', +b.dataset.lbPer === S.per); });
    var g = $('[data-lb-grp]'); if (g) g.setAttribute('aria-checked', S.grp ? 'true' : 'false');
    var f = $('[data-lb-flt]'); if (f) { f.classList.toggle('is-on', S.filt); f.setAttribute('aria-expanded', S.filt); $('[data-lb-flt-ar]').innerHTML = S.filt ? '&#9652;' : '&#9662;'; }
    var panel = $('[data-lb-fpanel]'); panel.hidden = !(S.filt && S.mode === 'list');
    if (!panel.hidden) buildPanel(panel);
  }
  function buildPanel(panel) {
    var rows = '';
    function opts(label, key, vals) {
      rows += '<div class="lb-fpanel__row"><span>' + label + '</span>' + vals.map(function (v) {
        return '<button type="button" data-lb-p="' + key + '" data-v="' + esc(v) + '" class="' + (S[key].indexOf(v) > -1 ? 'is-on' : '') + '">' + esc(v.replace(/^works:/, '')) + '<em>' + cards.filter(function (c) { return key === 'type' ? c.type === v : c.tags.indexOf(v) > -1; }).length + '</em></button>';
      }).join('') + '</div>';
    }
    if (typeOrder.length > 1) opts('Type', 'type', typeOrder);
    var tagList = $$('[data-lb-f="tag"]').map(function (i) { return i.value; });
    var worksList = tagList.filter(function (v) { return v.indexOf('works:') === 0; });
    var featList = tagList.filter(function (v) { return v.indexOf('works:') !== 0; });
    if (worksList.length) opts('Works with', 'tag', worksList);
    if (featList.length) opts('Features', 'tag', featList);
    if (maxP > minP) {
      var steps = [Math.ceil(maxP / 4), Math.ceil(maxP / 2), Math.ceil(maxP * 3 / 4)].filter(function (v, i, a) { return v > minP && a.indexOf(v) === i; });
      rows += '<div class="lb-fpanel__row"><span>Max price</span>' + steps.concat([maxP]).map(function (v) {
        return '<button type="button" data-lb-pmax="' + v + '" class="' + (S.max === v ? 'is-on' : '') + '">' + (v === maxP ? 'Any price' : 'Up to ' + money(v)) + '</button>';
      }).join('') + '</div>';
    }
    rows += '<div class="lb-fpanel__row"><span>Availability</span><button type="button" data-lb-pstock="0" class="' + (!S.stock ? 'is-on' : '') + '">All</button><button type="button" data-lb-pstock="1" class="' + (S.stock ? 'is-on' : '') + '">In stock only</button></div>';
    rows += '<button type="button" class="lb-clear" data-lb-clear>Clear all filters</button>';
    panel.innerHTML = rows;
  }
  function clearAll() { S.q = ''; S.type = []; S.tag = []; S.max = maxP; S.stock = false; render(); }
  function toggle(arr, v) { var i = arr.indexOf(v); if (i > -1) arr.splice(i, 1); else arr.push(v); }

  // option counts (static, over every product)
  $$('[data-lb-n]').forEach(function (n) {
    var k = n.dataset.lbN, v = n.dataset.v;
    n.textContent = cards.filter(function (c) { return k === 'type' ? c.type === v : c.tags.indexOf(v) > -1; }).length;
  });
  var pmin = $('[data-lb-pmin]'), pmax = $('[data-lb-pmax]');
  if (pmin) pmin.textContent = money(minP); if (pmax) pmax.textContent = money(maxP);

  function act(v) {
    if (!v || v.charAt(0) !== '#') return false;
    if (v === '#clear') { clearAll(); S.mode = 'grid'; render(); }
    else if (v === '#list') { S.mode = 'list'; render(); listEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    else if (v.indexOf('#search=') === 0) { S.q = decodeURIComponent(v.slice(8)); S.mode = 'grid'; render(); }
    else if (v.indexOf('#tag=') === 0) { S.tag = [decodeURIComponent(v.slice(5))]; S.mode = 'grid'; render(); }
    return true;
  }

  root.addEventListener('click', function (e) {
    var t = e.target, b;
    if ((b = t.closest('[data-lb-act]')) && act(b.dataset.lbAct)) { e.preventDefault(); return; }
    if ((b = t.closest('[data-lb-mode]'))) { S.mode = b.dataset.lbMode; render(); return; }
    if ((b = t.closest('[data-lb-per]'))) { S.per = +b.dataset.lbPer; render(); return; }
    if (t.closest('[data-lb-grp]')) { S.grp = !S.grp; render(); return; }
    if (t.closest('[data-lb-flt]')) { S.filt = !S.filt; render(); return; }
    if (t.closest('[data-lb-clear]')) { clearAll(); return; }
    if ((b = t.closest('[data-lb-p]'))) { toggle(S[b.dataset.lbP], b.dataset.v); render(); return; }
    if ((b = t.closest('[data-lb-pmax]'))) { S.max = +b.dataset.lbPmax; render(); return; }
    if ((b = t.closest('[data-lb-pstock]'))) { S.stock = b.dataset.lbPstock === '1'; render(); return; }
    // grid card stepper and add
    if ((b = t.closest('[data-lb-inc],[data-lb-dec]'))) {
      var i = b.closest('.lb-step').querySelector('input'); i.value = Math.max(1, (+i.value || 1) + (b.hasAttribute('data-lb-inc') ? 1 : -1)); return;
    }
    if ((b = t.closest('[data-lb-add]'))) { addOne(b); return; }
    // list stepper
    if ((b = t.closest('[data-lb-linc],[data-lb-ldec]'))) {
      var li = b.closest('.lb-step').querySelector('input'); li.value = Math.max(0, (+li.value || 0) + (b.hasAttribute('data-lb-linc') ? 1 : -1)); updateList(); return;
    }
    if (t.closest('[data-lb-lclear]')) { $$('[data-lb-lqty]').forEach(function (i) { i.value = 0; }); updateList(); return; }
    if (t.closest('[data-lb-bar-add]')) { addAll(); return; }
  });
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-lb-q]')) { S.q = t.value; render(); }
    else if (t.matches('[data-lb-price]')) { S.max = +t.value; render(); }
    else if (t.matches('[data-lb-lqty]')) updateList();
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-lb-f]')) { toggle(S[t.dataset.lbF], t.value); render(); }
    else if (t.matches('[data-lb-stock]')) { S.stock = t.checked; render(); }
    else if (t.matches('[data-lb-sort]')) { S.sort = t.value; render(); }
  });

  /* ---- list totals ---- */
  function updateList() {
    var units = 0, lines = 0;
    cards.forEach(function (c) { var i = c.row && c.row.querySelector('[data-lb-lqty]'); if (i) { var q = Math.max(0, parseInt(i.value, 10) || 0); units += q; if (q) lines++; } });
    var pct = pctFor(units), sub = 0, list = 0;
    cards.forEach(function (c) {
      var r = c.row; if (!r) return;
      var i = r.querySelector('[data-lb-lqty]'), q = i ? Math.max(0, parseInt(i.value, 10) || 0) : 0;
      var unit = c.price * (1 - pct / 100);
      $('[data-lb-unit]', r).textContent = money(unit);
      $('[data-lb-off]', r).textContent = pct ? pct + '% off' : '';
      $('[data-lb-ltotal]', r).textContent = q ? money(unit * q) : '–';
      r.classList.toggle('has-q', q > 0);
      sub += unit * q; list += c.price * q;
    });
    $('[data-lb-bar-n]').textContent = lines ? lines + (lines === 1 ? ' product' : ' products') + ' · ' + units + (units === 1 ? ' unit' : ' units') : 'No quantities yet';
    $('[data-lb-bar-save]').textContent = pct && units ? 'You save ' + money(list - sub) + ' (' + pct + '% off)' : (units ? 'Order 3+ units to save' : 'Set quantities in the list');
    $('[data-lb-bar-tax]').textContent = root.dataset.tax ? root.dataset.tax : '';
    $('[data-lb-bar-sub]').textContent = money(sub);
    var go = $('[data-lb-bar-add]'); go.disabled = !units;
  }

  /* ---- cart ---- */
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var n = document.querySelector('.header__cart-count');
      if (n) { n.dataset.n = c.item_count; var num = n.querySelector('.header__cart-count-number'); if (num) num.textContent = c.item_count; }
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
    }).catch(function () {});
  }
  function post(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }
  function addOne(btn) {
    var card = btn.closest('[data-lb-item]'), q = Math.max(1, parseInt(card.querySelector('[data-lb-qty]').value, 10) || 1);
    btn.disabled = true;
    post([{ id: +card.dataset.vid, quantity: q }]).then(function () {
      btn.textContent = 'Added ✓'; btn.classList.add('is-done'); refreshCount();
      setTimeout(function () { btn.textContent = 'Add to cart'; btn.classList.remove('is-done'); btn.disabled = false; }, 1400);
    }).catch(function () { btn.textContent = 'Try again'; btn.disabled = false; });
  }
  function addAll() {
    var items = [];
    cards.forEach(function (c) { var i = c.row && c.row.querySelector('[data-lb-lqty]'), q = i ? parseInt(i.value, 10) || 0 : 0; if (q > 0) items.push({ id: +c.row.dataset.vid, quantity: q }); });
    if (!items.length) return;
    var go = $('[data-lb-bar-add]'); go.disabled = true; go.textContent = 'Adding…';
    post(items).then(function () {
      $$('[data-lb-lqty]').forEach(function (i) { i.value = 0; });
      go.textContent = 'Added ✓'; refreshCount();
      setTimeout(function () { go.textContent = 'Add all to cart'; updateList(); }, 1400);
    }).catch(function () { go.textContent = 'Try again'; go.disabled = false; });
  }

  /* ---- banner ---- */
  var ban = $('[data-lb-ban]');
  if (ban) {
    var slides = $$('.lb-ban__slide', ban), dots = $$('.lb-ban__dots button', ban), cur_i = 0, timer;
    function go(n) { cur_i = (n + slides.length) % slides.length; slides.forEach(function (s, i) { s.classList.toggle('is-on', i === cur_i); }); dots.forEach(function (d, i) { d.classList.toggle('is-on', i === cur_i); }); }
    function start() { stop(); if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { go(cur_i + 1); }, 6000); }
    function stop() { clearInterval(timer); }
    ban.addEventListener('click', function (e) {
      var d = e.target.closest('.lb-ban__dots button');
      if (d) go(+d.dataset.i); else if (e.target.closest('[data-lb-prev]')) go(cur_i - 1); else if (e.target.closest('[data-lb-next]')) go(cur_i + 1); else return;
      start();
    });
    ban.addEventListener('mouseenter', stop); ban.addEventListener('mouseleave', start);
    start();
  }

  window.addEventListener('pageshow', refreshCount);
  render();
  if (location.hash === '#list') act('#list');
})();
